import { h, createElement, Component } from "preact";

const Picture = ({ img, width = 1000, alt }) => {
  let handle = "VbieTVjAQvq5BTkE9vIi";
  if (img) {
    handle = img.handle;
  }
  const cdn = "https://cdn.filestackcontent.com";
  return (
    <picture>
      <source
        srcset={`${cdn}/quality=value:100/output=format:webp/resize=width:${width}/${handle}`}
        type="image/webp"
      />
      <source
        srcset={`${cdn}/quality=value:100/output=format:png/resize=width:${width}/${handle}`}
        type="image/png"
      />
      <source
        srcset={`${cdn}/quality=value:100/output=format:jpg/resize=width:${width}/${handle}`}
        type="image/jpg"
      />
      <img
        src={`${cdn}/quality=value:100/output=compress:true,background:FFFFFF/resize=width:${width}/${handle}`}
        alt={alt}
        width={width}
        srcset={`${cdn}/quality=value:100/output=compress:true,background:FFFFFF/resize=width:${width}/${handle} 1x, ${cdn}/quality=value:100/output=compress:true,background:FFFFFF/resize=width:${width *
          2}/${handle} 2x`}
      />
    </picture>
  );
};
export default Picture;
